import { Trans, useTranslation } from 'react-i18next';
import { IBenefit } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { useEmployeeHasFlexibleBenefits } from '@/common/integrations/menhir/employee/flexible-benefits/flexible-benefits.hooks';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';

export const useCustomProps = (benefit: IBenefit) => {
  const { t } = useTranslation();
  const hasFlexibleBenefits = useEmployeeHasFlexibleBenefits();

  switch (benefit.slug) {
    case 'cashout':
      return {
        description: (
          <Trans i18nKey={t('dashboard.cashout.card_description')} />
        ),
      };
    case 'recreation':
    case 'fringe':
    case 'family-care-services':
    case 'it-transportation':
    case 'it-education': {
      return {
        description: (
          <Trans
            i18nKey={t(
              `dashboard.benefits.usage.${
                benefit.usage ? 'with_limit' : 'without_limit'
              }`
            )}
            values={{
              amount: benefit.usage
                ? MoneyUtils.moneyToString(benefit.usage.limit)
                : '',
            }}
          />
        ),
      };
    }
    case 'pension-funds':
      return {
        description: (
          <Trans
            i18nKey={t('dashboard.benefits.usage.pension_funds')}
            values={{
              amount: benefit.usage
                ? MoneyUtils.moneyToString(benefit.usage.limit)
                : '',
            }}
          />
        ),
      };
    case 'meals':
      if (hasFlexibleBenefits) {
        return {
          description: (
            <Trans i18nKey="catalog.categories.meals.description.es" />
          ),
        };
      }
    case 'es-public-transport':
      return {
        description: (
          <Trans i18nKey="general.benefits.es-public-transport.description" />
        ),
      };

    case 'es-childcare':
      return {
        description: (
          <Trans
            i18nKey={
              benefit.limits?.yearly
                ? 'general.benefits.es-childcare.description'
                : 'general.benefits.es-childcare.description.no_limit'
            }
            values={{
              limit: MoneyUtils.moneyToString(
                benefit.limits?.yearly ?? undefined
              ),
            }}
          />
        ),
      };
    case 'es-professional-development':
      return {
        description: <Trans i18nKey="general.labels.no_yearly_limit" />,
      };

    default:
      return null;
  }
};
